import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import TemplateCard from '../../components/TemplateCard';
import { getTemplates, deleteTemplate } from '../../api/client';

function getTemplateId(template) {
  return template?.id ?? template?._id?.$oid ?? template?._id;
}

export default function Templates() {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchTemplates = useCallback(() => {
    setLoading(true);
    setError(null);
    getTemplates(0, 10)
      .then((res) => setTemplates(res?.listOfItems ?? []))
      .catch((err) => {
        setError(err?.body?.message || err?.message || 'Failed to load templates');
        setTemplates([]);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    fetchTemplates();
  }, [fetchTemplates]);

  const handleDelete = useCallback(async (id) => {
    try {
      await deleteTemplate(id);
      setError(null);
      setTemplates((prev) => prev.filter((t) => getTemplateId(t) !== id));
    } catch (err) {
      setError(err?.body?.message || err?.message || 'Failed to delete template');
    }
  }, []);

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
        <div>
          <h1 className="h4 mb-1">Template Management</h1>
          <p className="text-muted mb-0">Manage your templates here.</p>
        </div>
        <Link to="/templates/new" className="btn btn-primary">
          <i className="bi bi-plus-lg me-2" />
          Create template
        </Link>
      </div>
      {error && (
        <div className="alert alert-danger py-2 small" role="alert">
          {error}
        </div>
      )}
      {loading ? (
        <div className="d-flex align-items-center justify-content-center py-5">
          <span className="spinner-border text-primary" role="status" aria-hidden="true" />
        </div>
      ) : (
        <div className="row g-4 mt-2">
          {templates.map((template) => (
            <div key={getTemplateId(template)} className="col-12 col-md-6">
              <TemplateCard template={template} onDelete={handleDelete} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
